import React, { useEffect, useState } from 'react';
import OptionSheet from './OptionSheet';

interface InstruccionAdicionalOptionProps {
  open: boolean;
  onClose: () => void;
  value: string;
  onChange: (v: string) => void;
  onAccept: (v: string) => void;
}

const InstruccionAdicionalOption: React.FC<InstruccionAdicionalOptionProps> = ({
  open,
  onClose,
  value,
  onChange,
  onAccept,
}) => {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    if (open) setLocal(value);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const content = (
    <div className="bg-white border border-neutral-200 rounded-lg p-4">
      <textarea
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder="Escribí instrucciones adicionales para personalizar la generación..."
        className="w-full text-[15px] text-neutral-900 resize-none border-none outline-none focus:ring-0 p-0 bg-transparent min-h-[160px]"
      />
    </div>
  );

  return (
    <OptionSheet
      open={open}
      onClose={() => {
        setLocal(value);
        onClose();
      }}
      onAccept={() => {
        onChange(local);
        onAccept(local);
      }}
      title="Instrucción adicional"
    >
      {content}
    </OptionSheet>
  );
};

export default InstruccionAdicionalOption;
